import { Box, Container } from '@mui/material';
import { Footer } from 'components/common/Footer';
import { Nav } from 'components/common/Nav';
import { Updater } from 'components/common/Updater';
import { Outlet } from 'react-router-dom';

export function DefaultLayout() {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <Nav />
        <Container
          sx={{
            px: { xs: 0.5, sm: 2, md: 4 },
            display: 'flex',
            overflow: 'auto',
            flexGrow: 1,
            flexDirection: 'column',
          }}
          maxWidth={false}
        >
          <Box sx={{ flexGrow: 1, py: { xs: 1, md: 4 } }}>
            <Updater />
            <Outlet />
          </Box>
          <Footer />
        </Container>
      </Box>
    </>
  );
}
